import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import { validateEmail, validateName } from "../../../_helpers/validators";
import {
  signup_user_action,
  google_login_action,
  select_role_user_action,
} from "../../../redux/_actions";

function useSignup(props) {
  //state from redux

  //initial states
  const [formData, setformData] = useState({});
  const [formInputsError, setFormInputsError] = useState({});
  const [loading, setloading] = useState(false);
  const [showPassword1, setshowPassword1] = useState(false);
  const [showPassword2, setshowPassword2] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [googleLoader, setGoogleLoader] = useState(false);

  React.useEffect(() => {
    setformData({
      full_name: "",
      email: "",
      password1: "",
      password2: "",
    });
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  //set states on input change
  const onInputChange = (value, key) => {
    let data = formData;

    //set form data
    data[key] = value;
    setformData(data);
  };

  // submit form
  const onSubmitClick = async (e) => {
    setloading(true);
    setFormInputsError({});
    if (validateForm()) {
      if (termsAccepted) {
        const loginData = await dispatch(signup_user_action(formData));
        // navigate or show error
        checkNavigate(loginData);
      } else {
        let form_errors = {
          formSubmitError: "Please accept terms and conditions.",
        };
        setFormInputsError(form_errors);
      }
    }

    setloading(false);
  };

  //navigate to screens
  const checkNavigate = async (loginData) => {
    if (loginData !== undefined) {
      const role = loginData.user && loginData.user.role;
      if (role === null) {
        let data = { role: "mentor" };

        const res = await dispatch(select_role_user_action(data));
        if (res.data) navigate("/mentor-onboard");
      } else {
        let form_errors = {
          formSubmitError:
            loginData.msg && loginData.msg !== ""
              ? loginData.msg && loginData.msg
              : "Can not create account",
        };
        setFormInputsError(form_errors);
      }
    } else {
      let form_errors = {
        formSubmitError:
          loginData.msg && loginData.msg !== ""
            ? loginData.msg && loginData.msg
            : "Can not create account with the provided credentials.",
      };
      setFormInputsError(form_errors);
    }
  };

  //google login
  const google_login = useGoogleLogin({
    onSuccess: (codeResponse) => successResponseGoogle(codeResponse),
    onError: (response) => failureResponseGoogle(response),
  });

  //google login success/failure
  const successResponseGoogle = async (response) => {
    const token = { access_token: response.access_token };

    if (token) {
      setGoogleLoader(true);
      const loginData = await dispatch(google_login_action(token));
      checkNavigate(loginData);
    }
    setGoogleLoader(false);
  };
  const failureResponseGoogle = (response) => {
    if (response.error !== "popup_closed_by_user")
      if (response.details.includes("Cookies are not enabled")) {
        let form_errors = {
          formSubmitError: "Please enable cookies.",
        };
        setFormInputsError(form_errors);
      } else {
        let form_errors = {
          formSubmitError: "Can not create account with google.",
        };
        setFormInputsError(form_errors);
      }
  };

  //change password show button
  const handleShowPassword = (key) => {
    switch (key) {
      case "password1":
        setshowPassword1(!showPassword1);
        break;
      case "password2":
        setshowPassword2(!showPassword2);
        break;
      default:
        return;
    }
  };
  const onTermsAccepted = (key) => {
    setTermsAccepted(!termsAccepted);
  };

  //validate form
  const validateForm = () => {
    let form_errors = {};
    let name_error = validateName(formData.full_name);

    //validate name
    if (formData.full_name.length === 0) {
      form_errors = {
        full_name: "Field can not be empty",
      };
      setFormInputsError(form_errors);
      return false;
    }
    if (name_error.length > 0) {
      form_errors = {
        full_name: name_error,
      };
      setFormInputsError(form_errors);
      return false;
    }
    //validate email
    if (formData.email.length === 0) {
      form_errors = {
        email: "Email cannot be empty",
      };
      setFormInputsError(form_errors);
      return false;
    }
    if (!validateEmail(formData.email)) {
      form_errors = {
        email: "Enter valid email",
      };
      setFormInputsError(form_errors);
      return false;
    }
    //validate password
    if (formData.password1.length === 0) {
      form_errors = {
        password1: "Field can not be empty",
      };
      setFormInputsError(form_errors);
      return false;
    }
    if (formData.password2.length === 0) {
      form_errors = {
        password2: "Field can not be empty",
      };
      setFormInputsError(form_errors);
      return false;
    }
    if (formData.password1.length < 8) {
      form_errors = {
        password1: "Please enter mininimum of 8 characters",
      };
      setFormInputsError(form_errors);
      return false;
    }
    if (formData.password2.length < 8) {
      form_errors = {
        password2: "Please enter mininimum of 8 characters",
      };
      setFormInputsError(form_errors);
      return false;
    }
    if (formData.password1 !== formData.password2) {
      form_errors = {
        password2: "Passwords do not match",
      };
      setFormInputsError(form_errors);
      return false;
    }

    return true;
  };

  return {
    formInputsError,
    loading,
    showPassword1,
    showPassword2,
    googleLoader,

    google_login,
    onTermsAccepted,
    onInputChange,
    onSubmitClick,
    handleShowPassword,
  };
}
export default useSignup;
